const documentValidationRules = {
    document: {
        allowedFormats: ['image/jpeg', 'image/png', 'application/pdf'],
        maxSizeMB: 5, // Tamaño máximo en MB
        message: 'jpeg, png o pdf',
    },
    other: {
        allowedFormats: ['application/pdf'],
        maxSizeMB: 5, // Tamaño máximo en MB
    },
    // Agrega más tipos de documentos según sea necesario
};

// Ejemplo de uso:
const getDocumentValidationsRules = (typeName: string) => {
    if (typeName.includes('CC')) return documentValidationRules.document;
    else return documentValidationRules.other;
};

export { getDocumentValidationsRules, documentValidationRules };
